"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidSurveyError = exports.SurveysServiceClient = void 0;
var SurveysServiceClient_1 = require("./SurveysServiceClient");
Object.defineProperty(exports, "SurveysServiceClient", { enumerable: true, get: function () { return __importDefault(SurveysServiceClient_1).default; } });
var InvalidSurveyError_1 = require("./errors/InvalidSurveyError");
Object.defineProperty(exports, "InvalidSurveyError", { enumerable: true, get: function () { return __importDefault(InvalidSurveyError_1).default; } });
//# sourceMappingURL=index.js.map